<template>
  <b-tabs class="emisiones" v-model="tabIndex">
    <b-tab active>
      <template slot="title">
        <h6 class="colorEmision">Proforma</h6>
        <div class="separador"></div>
      </template>
      <template v-if="tabIndex == 0">
        <proforma-emision :changeProforma="changeProforma" :emitirProforma="emitirProforma" @tabindex="changeTab"></proforma-emision>
      </template>
    </b-tab>
    <b-tab title="Emitidas">
      <template slot="title">
        <h6>Emitidas</h6>
      </template>
      <template v-if="tabIndex == 1">
        <proforma-consulta @tabindex="changeTab" @proforma="editProforma" @proformaRapida="proformaRapida"></proforma-consulta>
      </template>
    </b-tab>
    <b-tab title="Emitidas">
      <template slot="title">
        <h6 class="colorEmision">Orden Compra</h6>
        <div class="separador"></div>
      </template>
      <template v-if="tabIndex == 2">
        <orden-compra-emision :changeOrdenCompra="changeOrdenCompra" @tabindex="changeTab"></orden-compra-emision>
      </template>
    </b-tab>
    <b-tab title="Emitidas">
      <template slot="title">
        <h6>Emitidas</h6>
      </template>
      <template v-if="tabIndex == 3">
        <orden-compra-consulta @tabindex="changeTab" @ordencompra="editOrdenCompra"></orden-compra-consulta>
      </template>
    </b-tab>
    <b-tab title="Emitidas">
      <template slot="title">
        <h6 class="colorEmision">Orden Pago</h6>
        <div class="separador"></div>
      </template>
      <template v-if="tabIndex == 4">
        <orden-pago-emision :changeOrdenPago="changeOrdenPago" @tabindex="changeTab"></orden-pago-emision>
      </template>
    </b-tab>
    <b-tab title="Emitidas">
      <template slot="title">
        <h6>Emitidas</h6>
      </template>
      <template v-if="tabIndex == 5">
        <orden-pago-consulta @tabindex="changeTab" @ordenpago="editOrdenPago"></orden-pago-consulta>
      </template>
    </b-tab>
    <b-tab title="emision">
      <template slot="title">
        <h6 class="colorEmision">Nota Venta</h6>
        <div class="separador"></div>
      </template>
      <template v-if="tabIndex == 6">
        <nota-venta @tabindex="changeTab" :reciveItemNotaVenta="reciveItemNotaVenta"></nota-venta>
      </template>
    </b-tab>
    <b-tab title="Emitidas">
      <template slot="title">
        <h6>Emitidas</h6>
      </template>
      <template v-if="tabIndex == 7">
        <nota-venta-consulta @tabindex="changeTab" @nuevaNotaVentaClonada="nuevosItems"></nota-venta-consulta>
      </template>
    </b-tab>
    <b-tab title="emision">
      <template slot="title">
        <h6 class="colorEmision">Ticket Suministro</h6>
        <div class="separador"></div>
      </template>
      <template v-if="tabIndex == 8">
        <ticket-suministro @tabindex="changeTab"></ticket-suministro>
      </template>
    </b-tab>
    <vue-snotify></vue-snotify>
  </b-tabs>
</template>

<script>
import ProformaEmision from "@/components/proforma/ProformaEmision";
import ProformaConsulta from "@/components/proforma/ProformaConsulta";
import OrdenCompraEmision from "@/components/ordencompra/OrdenCompraEmision";
import OrdenCompraConsulta from "@/components/ordencompra/OrdenCompraConsulta";
import OrdenPagoEmision from "@/components/ordenpago/OrdenPagoEmision";
import OrdenPagoConsulta from "@/components/ordenpago/OrdenPagoConsulta";
import notaVenta from "@/components/notaventa/notaVenta";
import notaVentaConsulta from "@/components/notaventa/notaVentaConsulta";
import ticketSuministro from "@/components/ticketSuministro/ticketSuministro";
// import OrdenPagoCaja from "@/components/ordenpago/OrdenPagoCaja";
export default {
  name: "Proforma",
  components: {
    ProformaEmision,
    ProformaConsulta,
    OrdenCompraEmision,
    OrdenCompraConsulta,
    OrdenPagoEmision,
    OrdenPagoConsulta,
    notaVenta,
    notaVentaConsulta,
    ticketSuministro
    // OrdenPagoCaja
  },
  data: () => {
    return {
      tabIndex: 0,
      changeProforma: {},
      changeOrdenCompra: {},
      changeOrdenPago: {},
      emitirProforma:{},
      reciveItemNotaVenta:{}
    };
  },
  mounted() {
    this.assgntipocomprobante();
  },
  updated() {
    this.assgntipocomprobante();
  },
  methods: {
    assgntipocomprobante() {
      switch (this.tabIndex) {
        case 0:
          this.$store.commit("setcomprobante", 6);
          break;
        case 2:;
          this.$store.commit("setcomprobante", 7);
          break;
        case 4:
          this.$store.commit("setcomprobante", 8);
          break;
      }
    },
    changeTab(value) {
      this.tabIndex = value;
    },
    editProforma(value) {
      this.changeProforma = value;
    },
    proformaRapida(value) {
      this.emitirProforma = value;
    },
    editOrdenCompra(value) {
      this.changeOrdenCompra = value;
    },
     editOrdenPago(value) {
      this.changeOrdenPago = value;
    },
    nuevosItems(value){
      this.reciveItemNotaVenta = value
    }
  }
};
</script>

<style>
.colorEmision {
  font-weight: bold;
  color: #00004d;
}
.separador {
  background-color: #ffc12c;
  width: 100%;
  height: 2px;
}
</style>